import { z } from "zod";

export const personaStatusFilterSchema = z.enum(["all", "draft", "active", "archived"]);

/**
 * 絞り込み条件を URL に持たせる。
 * リンクを共有すれば相手にも同じ画面が再現される（原則 7）。
 */
export const personasSearchSchema = z.object({
  q: z.string().trim().max(100).catch("").default(""),
  status: personaStatusFilterSchema.catch("all").default("all")
});

export type PersonaStatusFilter = z.infer<typeof personaStatusFilterSchema>;
export type PersonasSearch = z.infer<typeof personasSearchSchema>;
